var _rect, _g, _path, _path2, _path3, _path4, _path5, _line, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g2, _rect8, _path6, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAirSuccess = function SvgAirSuccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 145,
    viewBox: "0 0 130 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.695068,
    y: 54.3408,
    width: 108.681,
    height: 54.9467,
    rx: 6.8951,
    transform: "rotate(-30 0.695068 54.3408)",
    fill: "#E7E7E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_47135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.553 79.9116L33.3025 78.9015L33.3834 68.9412L38.1944 66.1636C38.9204 65.7444 39.1681 64.82 38.749 64.094C38.3298 63.3679 37.4054 63.1202 36.6793 63.5394L31.8683 66.317L23.202 61.407L21.4525 62.417L27.9321 68.5896L23.1211 71.3673L20.5464 69.938L19.2343 70.6955L22.1291 73.6894L23.2745 77.6934L24.5866 76.9358L24.6361 73.9915L29.4471 71.2138L31.553 79.9116Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.342 23.48L98.813 24.2957L85.1672 32.1741L84.6963 31.3584L98.342 23.48ZM86.5691 34.6022L100.215 26.7238L99.273 25.0924L85.6272 32.9708L86.5691 34.6022ZM100.675 27.5206L101.146 28.3363L87.5001 36.2146L87.0291 35.3989L100.675 27.5206ZM101.617 29.152L102.077 29.9487L88.431 37.8271L87.971 37.0303L101.617 29.152ZM103.479 32.3768L103.019 31.5801L89.3729 39.4585L90.3038 41.0709L103.95 33.1925L103.479 32.3768Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.908 41.7815L108.441 40.9725L94.7954 48.8509L95.2624 49.6599L108.908 41.7815ZM93.4051 46.4428L107.051 38.5645L107.985 40.1824L94.3392 48.0608L93.4051 46.4428ZM106.595 37.7743L106.128 36.9653L92.4818 44.8437L92.9489 45.6527L106.595 37.7743ZM105.661 36.1564L105.204 35.3662L91.5586 43.2446L92.0148 44.0348L105.661 36.1564ZM103.814 32.9582L104.27 33.7483L90.6245 41.6267L89.7012 40.0276L103.347 32.1492L103.814 32.9582Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7588 24.2024L98.2878 23.3867L84.6421 31.2651L85.113 32.0808L98.7588 24.2024ZM83.2402 28.8369L96.886 20.9585L97.8278 22.59L84.1821 30.4683L83.2402 28.8369ZM96.426 20.1618L95.955 19.3461L82.3093 27.2245L82.7802 28.0402L96.426 20.1618ZM95.4841 18.5304L95.0241 17.7337L81.3783 25.6121L81.8383 26.4088L95.4841 18.5304ZM93.6222 15.3055L94.0822 16.1023L80.4364 23.9806L79.5055 22.3682L93.1512 14.4898L93.6222 15.3055Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14262 60.3121C2.23859 57.0143 3.36852 52.7973 6.6664 50.8933L88.8445 3.44774C92.1423 1.54372 96.3593 2.67364 98.2633 5.97152L98.654 6.64812L4.53325 60.9888L4.14262 60.3121Z",
    fill: "#FB8400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 95.9547C26.6247 99.2526 30.8417 100.383 34.1395 98.4785L116.318 51.0329C119.615 49.1289 120.745 44.9119 118.841 41.6141L118.451 40.9375L24.33 95.2781L24.7207 95.9547Z",
    fill: "#FB8400"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.7221,
    y1: 16.2199,
    x2: 94.1955,
    y2: 63.8052,
    stroke: "#BFBFBF",
    strokeWidth: 1.37902,
    strokeDasharray: "5.17 5.17"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8457,
    y: 49.488,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 43.8457 49.488)",
    fill: "#FB8400"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3962,
    y: 50.9019,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 41.3962 50.9019)",
    fill: "#FB8400"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4368,
    y: 57.8999,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 45.4368 57.8999)",
    fill: "#FB8400"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4768,
    y: 64.8977,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 49.4768 64.8977)",
    fill: "#FB8400"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.886,
    y: 56.4858,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 47.886 56.4858)",
    fill: "#FB8400"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.926,
    y: 63.4834,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 51.926 63.4834)",
    fill: "#FB8400"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_47135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.6238,
    y: 54.3408,
    width: 108.681,
    height: 54.9467,
    rx: 6.8951,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5617 91.9139L29.5818 91.9139L34.6321 83.3285L40.1873 83.3285C41.0257 83.3285 41.7024 82.6517 41.7024 81.8134C41.7024 80.975 41.0257 80.2983 40.1873 80.2983L34.6321 80.2983L29.5818 71.7129L27.5617 71.7129L30.0868 80.2983L24.5316 80.2983L23.0165 77.7732L21.5014 77.7732L22.5115 81.8134L21.5014 85.8536L23.0165 85.8536L24.5316 83.3285L30.0868 83.3285L27.5617 91.9139Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 76.438L113.618 77.3799L97.8616 77.3799L97.8616 76.438L113.618 76.438ZM97.8616 80.1837L113.618 80.1837L113.618 78.2999L97.8616 78.2999L97.8616 80.1837ZM113.618 81.1036L113.618 82.0455L97.8616 82.0455L97.8616 81.1036L113.618 81.1036ZM113.618 82.9874L113.618 83.9074L97.8616 83.9074L97.8616 82.9874L113.618 82.9874ZM113.618 86.7112L113.618 85.7912L97.8616 85.7912L97.8616 87.6531L113.618 87.6531L113.618 86.7112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 97.5708L113.618 96.6367L97.8616 96.6367L97.8616 97.5708L113.618 97.5708ZM97.8616 93.8561L113.618 93.8561L113.618 95.7243L97.8616 95.7243L97.8616 93.8561ZM113.618 92.9437L113.618 92.0096L97.8616 92.0096L97.8616 92.9437L113.618 92.9437ZM113.618 91.0755L113.618 90.1631L97.8616 90.1631L97.8616 91.0755L113.618 91.0755ZM113.618 87.3825L113.618 88.2949L97.8616 88.2949L97.8616 86.4484L113.618 86.4484L113.618 87.3825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 77.2717L113.618 76.3298L97.8616 76.3298L97.8616 77.2717L113.618 77.2717ZM97.8616 73.5261L113.618 73.5261L113.618 75.4098L97.8616 75.4098L97.8616 73.5261ZM113.618 72.6061L113.618 71.6642L97.8616 71.6642L97.8616 72.6061L113.618 72.6061ZM113.618 70.7223L113.618 69.8023L97.8616 69.8023L97.8616 70.7223L113.618 70.7223ZM113.618 66.9985L113.618 67.9185L97.8616 67.9185L97.8616 66.0566L113.618 66.0566L113.618 66.9985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6238 61.2359C13.6238 57.4279 16.7108 54.3408 20.5189 54.3408H115.41C119.218 54.3408 122.305 57.4279 122.305 61.2359V62.0172H13.6238V61.2359Z",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6235 102.392C13.6235 106.2 16.7106 109.287 20.5186 109.287H115.41C119.218 109.287 122.305 106.2 122.305 102.392V101.611H13.6235V102.392Z",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.8648,
    y1: 54.3408,
    x2: 89.8648,
    y2: 109.287,
    stroke: "#BFBFBF",
    strokeWidth: 1.37902,
    strokeDasharray: "5.17 5.17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 71.7134,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 71.7134,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 71.7134)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 79.7939,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 79.7939)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 87.8743,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 87.8743)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 79.7939,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 87.8743,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6824,
    y: 93.3647,
    width: 51.6351,
    height: 51.6351,
    rx: 25.8176,
    fill: "#0CDA83"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0673 132.952L43.4277 119.898L46.5876 116.634L56.0673 126.425L76.4125 105.413L79.5723 108.676L56.0673 132.952Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_47135",
    x: 6.72844,
    y: 41.9262,
    width: 122.472,
    height: 68.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.51956
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.44755
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_47135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_47135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_47135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2412,
    height: 24.2412,
    fill: "white",
    transform: "translate(34.438 52.5872) rotate(60)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/air-success.9c638298.svg";
export { ForwardRef as ReactComponent };